import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import type { LeadSource } from "views/leads-id/types";

// One cache entry shared by every lead-source picker and the Lead sources grid:
// CreateModal / EditModal / DeleteModal refetch this key, so a change made in
// one place shows up in all of them. The cached shape is the raw `{ items }`
// response — keep it that way, every consumer reads `data.items`.
const LEAD_SOURCES_QUERY_KEY = ["LEAD_SOURCES_LIST"];

const fetchLeadSources = () =>
  instance
    .get<{ items: LeadSource[] }>("/portal/v1/boom_crm/lead_sources")
    .then((res) => res.data);

export const useLeadSources = ({
  enabled = true,
  staleTime
}: { enabled?: boolean; staleTime?: number } = {}) =>
  useQuery({
    queryKey: LEAD_SOURCES_QUERY_KEY,
    queryFn: fetchLeadSources,
    enabled,
    staleTime
  });
